import {
  UPDATE_PRACTICE,
  UPDATE_PRACTICE_SUCCESS,
  UPDATE_PRACTICE_FAILURE,
} from 'store/updatePractice/updatePracticeAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updatePracticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PRACTICE:
      return { ...state, loading: true };
    case UPDATE_PRACTICE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_PRACTICE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updatePracticeReducer;
